// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2203":"48d2f114","8719":"48d2f114"}[chunkId] + ".chunk.css";
};